import { Box, Skeleton, useTheme } from '@mui/material';

interface ServiceNationIframeSkeletonProps {
  testId?: string;
  // Title and subtitle placeholders, hidden where the real heading is already on screen
  showHeading?: boolean;
}

// Placeholder for an embedded Service Nation page while its SSO URL is generated and the page loads
export function ServiceNationIframeSkeleton({
  testId,
  showHeading = true,
}: ServiceNationIframeSkeletonProps) {
  const theme = useTheme();

  return (
    <Box
      data-testid={testId}
      sx={{ p: theme.spacing(4), width: '100%' }}
    >
      {showHeading && (
        <>
          <Skeleton animation="wave" height={theme.spacing(4)} sx={{ width: '25%', mb: theme.spacing(1) }} />
          <Skeleton animation="wave" height={theme.spacing(2)} sx={{ width: '45%', mb: theme.spacing(4) }} />
        </>
      )}
      <Skeleton
        animation="wave"
        variant="rounded"
        height={theme.spacing(30)}
        sx={{ borderRadius: theme.spacing(3) }}
      />
    </Box>
  );
}
